import script from "./TransferTransportTypes.vue?vue&type=script&setup=true&lang=js"
export * from "./TransferTransportTypes.vue?vue&type=script&setup=true&lang=js"

import "./TransferTransportTypes.vue?vue&type=style&index=0&id=76bd43a6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76bd43a6"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCard});
